import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import qs from 'qs';
import { unionBy } from 'lodash';
// Results state

const results = (state = [], { type, payload }) => {
  const result = unionBy(state, payload, 'id');
  switch (type) {
    case 'PHASE_LIST_SUCCESS':
      return [...result];
    case 'PHASE_RESOURCE_CREATE_SUCCESS':
    case 'PHASE_RESOURCE_UPDATE_SUCCESS':
    case 'PHASE_RESET_PAGINATION':
      return [];
    default:
      return state;
  }
};

const exportResults = (state = [], { type, payload }) => {
  switch (type) {
    case 'EXPORT_PHASES_SUCCESS':
      return payload;
    default:
      return state;
  }
};

// Filters state

const defaultFilters = {
  data: {},
  location: {},
  idsByFilter: [],
};

const filters = (state = defaultFilters, { type, payload }) => {
  switch (type) {
    case 'LOGIN_USER_SUCCESS':
    case 'USER_GET_SESSION_SUCCESS':
      return {
        ...state,
        location: payload.preferences.saved_location_filters || state.location,
      };
    case 'UPDATE_PHASE_FILTERS_LOCATION_REQUEST':
      return {
        ...state,
        location: Object.assign({}, payload),
      };
    case 'PHASE_SET_FILTER':
      return {
        ...state,
        data: Object.assign({}, payload),
      };
    case 'PHASE_RESET_FILTERS':
      return { ...defaultFilters };
    default:
      return state;
  }
};

// Common (errors, loading) state

const initialCommon = {
  loading: false,
  loaded: false,
  errors: {},
};

const common = (state = initialCommon, { type, payload }) => {
  switch (type) {
    case 'PHASE_LIST_REQUEST':
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case 'PHASE_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: {},
      };
    case 'PHASE_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: payload.errors,
      };
    case 'EXPORT_PHASES_FAILURE':
      return {
        ...state,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

// Pagination state

const initPagination = {
  current_page: 0,
  next_page: 1,
  prev_page: null,
  total_count: 0,
  total_pages: 0,
};

const pagination = (state = initPagination, { type, meta }) => {
  switch (type) {
    case 'PHASE_RESET_PAGINATION':
    case 'PHASE_RESOURCE_CREATE_SUCCESS':
    case 'PHASE_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        ...initPagination,
      };
    case 'PHASE_LIST_SUCCESS':
    case 'SAVED_FILTERS_LIST_SUCCESS':
      return {
        ...state,
        ...meta,
      };
    case 'PHASE_LIST_FAILURE':
      return {
        ...state,
        next_page: null,
      };
    default:
      return state;
  }
};

export default combineReducers({
  results,
  exportResults,
  common,
  filters,
  pagination,
});

const getList = state => state.results;
const getExportList = state => state.exportResults;
const getHasNextPage = state =>
  state.pagination.next_page !== null && state.pagination.next_page !== undefined;
const getPage = state => state.pagination.current_page;
const getNextPage = state => state.pagination.next_page;
const getLoading = state => state.common.loading;
const getErrors = state => state.common.errors;
const getFiltersData = state => state.filters.data;
const getFiltersLocation = state => state.filters.location;

const getCurrentQuery = createSelector(
  getFiltersData,
  getFiltersLocation,
  (data, location) => qs.stringify(Object.assign({}, data, location)),
);

const getCurrentQueryNoLocation = createSelector(
  getFiltersData,
  data => qs.stringify(Object.assign({}, data)),
);

export {
  getList,
  getExportList,
  getHasNextPage,
  getNextPage,
  getPage,
  getCurrentQueryNoLocation,
  getLoading,
  getErrors,
  getCurrentQuery,
  getFiltersData,
  getFiltersLocation,
};



// WEBPACK FOOTER //
// ./client/app/reducers/phases.js